/**
 * Created by pawel on 08.05.2014.
 */
export default class ControllerKeyboard {
  // KEYCODE_ENTER: 13
  // KEYCODE_SPACE: 32
  // KEYCODE_UP: 38
  // KEYCODE_DOWN: 40
  // KEYCODE_LEFT: 37
  // KEYCODE_RIGHT: 39

  constructor(game, hero) {
    this.game = game;
    this.hero = hero;

    this.start();

    console.log('ControllerKeyboard');
  }

  start() {
    this.keyUp = this.game.input.keyboard.addKey(Phaser.KeyCode.SPACEBAR);
    this.keyUp.onDown.add(this.onPressUp, this);
    this.keyUp.onUp.add(this.onReleaseUp, this);

    this.game.input.keyboard.addKeyCapture([Phaser.KeyCode.SPACEBAR]);
  }

  stop() {
    if (!this.keyUp) {
      return;
    }

    this.game.input.keyboard.removeKey(Phaser.KeyCode.UP);
    this.keyUp.onDown.remove(this.onPressUp, this);
    this.keyUp.onUp.remove(this.onReleaseUp, this);

    this.keyUp = null;

    this.game.input.keyboard.removeKeyCapture([Phaser.KeyCode.SPACEBAR]);
  }

  onPressUp() {
    this.hero.actionA();
  }

  onReleaseUp() {
    this.hero.releaseActionA();
  }
}



// WEBPACK FOOTER //
// ./js/app/games/chase/controllers/ControllerKeyboard.js